var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5625 8.25H8.4375C7.40625 8.25 6.5625 8.925 6.5625 9.75V20.25C6.5625 21.075 7.40625 21.75 8.4375 21.75H21.5625C22.5938 21.75 23.4375 21.075 23.4375 20.25V9.75C23.4375 8.925 22.5938 8.25 21.5625 8.25ZM21.5625 9.75V12H8.4375V9.75H21.5625ZM21.5625 13.5V16.5H8.4375V13.5H21.5625ZM8.4375 20.25V18H21.5625V20.25H8.4375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/Table.e65adfc9cf8d4faada1c8bc5d9002f4a.svg";
export { ForwardRef as ReactComponent };